import '../../i18n';
import {useTranslation} from 'react-i18next';
import React, { useState, useEffect } from 'react';
import { store } from 'react-notifications-component';
import { IoIosClose } from 'react-icons/io';
import { FiFolder } from 'react-icons/fi';

import { PRIMARY_COLOR, PALE_WHITE_6 } from '../../appearance/Colors';

function CreatedFolderNotification({ notificationId, toFolder, setSelectedFolder, title }) {
    const {t: lnT} = useTranslation();

    const [progress, setProgress] = useState(100);
    const [timeLeft, setTimeLeft] = useState(10);

    useEffect(() => {
        var downloadTimer = setInterval(function () {
            if (timeLeft <= 0) {
                clearInterval(downloadTimer);
            }
            // document.getElementById('progressBar').value = 10 - timeleft;
            setTimeLeft(timeLeft - 1);

            setProgress(progress - 10);
        }, 1000);
        return () => {
            // cleanup
        };
    }, [timeLeft]);

    // if (progress > 0) {
    //     setTimeout(() => {
    //         setProgress(progress - 20);
    //     }, 10);
    // } else {
    //     setProgress(100);
    // }

    return (
        <div
            className="luckynote-toast luckynote-toast--clickable"
            onClick={() => {
                // close(key);
                console.log('go to this folder', toFolder);
                store.removeNotification(notificationId);
                setSelectedFolder(toFolder);
            }}
        >
            <div className="luckynote-toast__row">
                <div className="luckynote-toast__icon">
                    <FiFolder color={PALE_WHITE_6} size={18} />
                </div>
                {/* <ProgressRing radius={60} stroke={4} progress={progress} /> */}
                <div className="luckynote-toast__body">
                    <div className="luckynote-toast__copy">
                        <div className="luckynote-toast__title">
                            {title ? title : lnT('folders:movedTo_44f8b879')} {toFolder.title}
                        </div>
                        <span className="luckynote-toast__description">{lnT('folders:viewFolder')}</span>
                    </div>
                    <div className="luckynote-toast__spacer"></div>
                    {/* <div style={{ justifyContent: 'center', display: 'flex' }}>
                        <IoIosArrowForward size={20}></IoIosArrowForward>
                    </div> */}
                </div>
            </div>
            <div
                className="luckynote-toast__floating-close"
                onClick={e => {
                    e.stopPropagation();
                    store.removeNotification(notificationId);
                }}
            >
                <IoIosClose color={PRIMARY_COLOR} size={18} />
            </div>
        </div>
    );
}

export default CreatedFolderNotification;
